/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { breakpoints } from '@coursera/cds-core';

import DomainMetatags from 'bundles/browse-common/components/DomainMetatags';
import HorizontalSpacing from 'bundles/browse-common/components/HorizontalSpacing';
import RoleCitation from 'bundles/browse-common/components/RoleCitation';
import { useDomainEntity } from 'bundles/browse-common/contexts/DomainEntityContext';
import BrowseBreadcrumbsRenderer from 'bundles/browse-common/renderers/BrowseBreadcrumbsRenderer';
import BrowsePageConfigComponentRenderer from 'bundles/browse-common/renderers/BrowsePageConfigComponentRenderer';
import { useComponentsConfig } from 'bundles/page-config-common/contexts/ComponentsConfigContext';

const styles = {
  root: css`
    margin-top: var(--cds-spacing-200);
    ${breakpoints.down('sm')} {
      margin-top: var(--cds-spacing-100);
    }
  `,
  breadcrumbs: css`
    margin-bottom: var(--cds-spacing-400);
    ${breakpoints.down('sm')} {
      margin-bottom: var(--cds-spacing-200);
    }
  `,
};

const DomainV2RootContent = () => {
  const pageConfigComponents = useComponentsConfig()?.filter(Boolean) ?? [];

  const { domain } = useDomainEntity() ?? {};

  return (
    <div css={styles.root}>
      <div css={styles.breadcrumbs}>
        <HorizontalSpacing>
          <BrowseBreadcrumbsRenderer />
        </HorizontalSpacing>
      </div>
      <BrowsePageConfigComponentRenderer pageConfigComponents={pageConfigComponents} />
      {pageConfigComponents.some((component) => component.__typename === 'PageConfig_ExploreRolesComponent') && (
        <RoleCitation />
      )}
      {domain && <DomainMetatags domain={domain} />}
    </div>
  );
};

export default DomainV2RootContent;
